import { render, staticRenderFns } from "./purchaserList.vue?vue&type=template&id=129a5093&scoped=true"
import script from "./purchaserList.vue?vue&type=script&lang=js"
export * from "./purchaserList.vue?vue&type=script&lang=js"
import style0 from "./purchaserList.vue?vue&type=style&index=0&id=129a5093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a5093",
  null
  
)

export default component.exports